// extracted by mini-css-extract-plugin
export var bubble = "_3j-0";
export var container = "_3j-3";
export var contrastBorder = "_3j-4";
export var greyOut = "_3j-2";
export var initialsWrapper = "_3j-1";
export var large = "_3j-9";
export var medium = "_3j-8";
export var mediumSmall = "_3j-7";
export var mediumSmallMedium = "_3j-c";
export var micro = "_3j-5";
export var small = "_3j-6";
export var tiny = "_3j-b";
export var xTiny = "_3j-a";